import { useCallback, useMemo } from 'react';
import type { Bedrooms } from 'app/shared/types/Bedrooms';
import type { PropertyTypes } from 'app/shared/types/PropertyTypes';
import { handleRentalMarketFilterChange } from 'app/shared/flux/actions/FilterActions';
import filterUtils from 'app/shared/utils/filterUtils';
import { trackEvent } from 'app/shared/utils/analytics/trackEvent';
import { gaEvents } from 'app/shared/constants/AnalyticsConstants';

import type { bedroomsType, FilterType, propertyTypesType } from 'app/shared/types/Filters';
import type { Dispatch } from 'redux';

export function useRentalMarketFilters(filter: FilterType, dispatch: Dispatch<any>) {
    const bedrooms = useMemo(() => filterUtils.filterToBedroomsEnum(filter.bedrooms as bedroomsType), [filter]);
    const setBedrooms = useCallback(
        (bedrooms: Bedrooms) => {
            trackEvent({ ...gaEvents.BED_COUNT_FILTER, label: bedrooms });
            return dispatch(
                handleRentalMarketFilterChange({
                    bedrooms: filterUtils.bedroomsEnumToFilter(bedrooms),
                    propertyTypes: filter.propertyTypes
                })
            );
        },
        [dispatch, filter]
    );
    const propertyTypes = useMemo(
        () => filterUtils.filterToPropertyTypesEnum(filter.propertyTypes as propertyTypesType),
        [filter]
    );
    const setPropertyTypes = useCallback(
        (propertyTypes: PropertyTypes) => {
            trackEvent({ ...gaEvents.PROPERTY_TYPE_FILTER, label: propertyTypes });
            return dispatch(
                handleRentalMarketFilterChange({
                    bedrooms: filter.bedrooms,
                    propertyTypes: filterUtils.propertyTypesEnumToFilter(propertyTypes)
                })
            );
        },
        [dispatch, filter]
    );
    return { bedrooms, setBedrooms, propertyTypes, setPropertyTypes };
}
